export {getScrollParent} from '../../../src/utils/getScrollParent';
